import client from '@/shared/apis/client'
import { type SoapContentItem } from '@/shared/types/yakurekiSoap'

// 訪問報告書の編集保存に送る fields。訪問時状況キーと医師への伝達事項 (physician_message) を
// SoapContentItem[] で送る。back home_care の HomeVisitReportUpdateSerializer に対応
// (キーはゆるく受ける契約)。
export type HomeVisitReportFields = Record<string, SoapContentItem[]>

// PATCH /api/request-events/<id>/home-visit-report/ — **触ったキーだけ** を送る。
// back は送られたキーだけを差し替えるので、触っていない欄は client の cache が古くても
// 壊れない。行を消す操作は「そのキーを空配列で送る」で表す。
// 読み取りの正典は event detail の soaps サイドカーなので、保存後は detail を invalidate すれば
// 反映される。
export const patchHomeVisitReport = async (
  yakurekiId: string,
  fields: HomeVisitReportFields
): Promise<void> => {
  await client.patch(`/api/request-events/${yakurekiId}/home-visit-report/`, {
    fields,
  })
}
